import { Routes } from "../../../../../AppRoutes";
import { EnvKey } from "../../../../../constants";
import { EnvHelper } from "../../../../../helper";
import {
  AFLNoSalaryDetail,
  AFLSuspendContractDetail,
  AccidentLeaveApplicationDetail,
  AccidentNotificationDetail,
  ApplicationForLeaveDetail,
  MaternityLeaveApplicationDetail,
  SickLeaveApplicationDetail,
  TerminationContractApplicationDetail,
} from "../components";
import { AFLType } from "../models";

export const getDetailTemplate = (aflType: AFLType | undefined) => {
  switch (aflType) {
    case AFLType.AccidentLeaveApplication:
      return AccidentLeaveApplicationDetail;
    case AFLType.AccidentNotification:
      return AccidentNotificationDetail;
    case AFLType.AFLNoSalary:
      return AFLNoSalaryDetail;
    case AFLType.ApplicationForLeave:
      return ApplicationForLeaveDetail;
    case AFLType.MaternityLeaveApplication:
      return MaternityLeaveApplicationDetail;
    case AFLType.SickLeaveApplication:
      return SickLeaveApplicationDetail;
    case AFLType.AFLSuspendContract:
      return AFLSuspendContractDetail;
    case AFLType.TerminationContractApplication:
      return TerminationContractApplicationDetail;
    default:
      return () => <div />;
  }
};

export const getSiteUrl = (aflType: AFLType | undefined, pathname: string) => {
  const newPathName = pathname.toLowerCase();
  switch (aflType) {
    // case AFLType.AccidentLeaveApplication:
    //   return AccidentLeaveApplicationDetail;
    // case AFLType.AccidentNotification:
    //   return AccidentNotificationDetail;
    case AFLType.AFLNoSalary:
      if (newPathName.includes("dad")) return EnvHelper.getValue(EnvKey.APPROVER_AFL_NO_SALARY_DAD_URL);
      return EnvHelper.getValue(EnvKey.APPROVER_AFL_NO_SALARY_TSN_URL);
    case AFLType.ApplicationForLeave:
      if (newPathName.includes("nba")) return EnvHelper.getValue(EnvKey.APPROVER_AFL_NBA_URL);
      if (newPathName.includes("dad")) return EnvHelper.getValue(EnvKey.APPROVER_AFL_DAD_URL);
      return EnvHelper.getValue(EnvKey.APPROVER_AFL_URL);
    case AFLType.MaternityLeaveApplication:
      if (newPathName.includes("dad")) return EnvHelper.getValue(EnvKey.APPROVER_AFL_MATERNITY_DAD_URL);
      return EnvHelper.getValue(EnvKey.APPROVER_AFL_MATERNITY_DAD_URL);
    case AFLType.SickLeaveApplication:
      if (newPathName.includes("dad")) return EnvHelper.getValue(EnvKey.APPROVER_AFL_SICK_DAD_URL);
      return EnvHelper.getValue(EnvKey.APPROVER_AFL_SICK_DAD_URL);
    case AFLType.AFLSuspendContract:
      if (newPathName.includes("dad")) return EnvHelper.getValue(EnvKey.APPROVER_AFL_SUSPEND_CONTRACT_DAD_URL);
      return EnvHelper.getValue(EnvKey.APPROVER_AFL_SUSPEND_CONTRACT_TSN_URL);
    case AFLType.TerminationContractApplication:
      if (newPathName.includes("dad")) return EnvHelper.getValue(EnvKey.APPROVER_AFL_TERMINATION_CONTRACT_DAD_URL);
      return EnvHelper.getValue(EnvKey.APPROVER_AFL_TERMINATION_CONTRACT_TSN_URL);

    default:
      return () => <div />;
  }
};

export const getBackLink = (aflType: AFLType | undefined, pathname: string) => {
  switch (aflType) {
    // case AFLType.AccidentLeaveApplication:
    //   return AccidentLeaveApplicationDetail;
    // case AFLType.AccidentNotification:
    //   return AccidentNotificationDetail;
    case AFLType.AFLNoSalary:
      if (pathname.includes("dad")) return Routes.noSalaryLeaveDADPage.path;
      return Routes.absenceNoSalary.path; //REPLACE TSN
    case AFLType.ApplicationForLeave:
      if (pathname.includes("nba")) return Routes.absenceLetterNBAPage.path;
      if (pathname.includes("dad")) return Routes.absenceLetterDADPage.path;
      return Routes.absenceLetterPage.path;
    case AFLType.MaternityLeaveApplication:
      if (pathname.includes("dad")) return Routes.maternityLeaveDADPage.path;
      return Routes.maternityLeaveDADPage.path;
    case AFLType.SickLeaveApplication:
      if (pathname.includes("dad")) return Routes.sickLeaveDADPage.path;
      return Routes.sickLeaveDADPage.path;
    case AFLType.AFLSuspendContract:
      if (pathname.includes("dad")) return Routes.suspendContractDADPage.path;
      else if (pathname.includes("tsn")) return Routes.absenceSuspendConstract.path;
      return Routes.suspendContractDADPage.path;
    case AFLType.TerminationContractApplication:
      if (pathname.includes("dad")) return Routes.terminationContractDADPage.path;
      else if (pathname.includes("tsn")) return Routes.absenceTerminateConstract.path;
      return Routes.terminationContractDADPage.path;
    default:
      return () => <div />;
  }
};
